export const tcContent = {
    "Your ifc Points:": "您的ifc積分:",
    "ifc Points": " ifc積分",
    "Out of stock": "已換罄",
    "Low in stock": "尚餘少量",
    "Redemption period": "換領期",
    "Valid until": "有效期至",
    "Required ifc Points: ": "所需ifc積分: ",
    "Redeem": "換領",
    "Confirm to redeem with x,xxx ifc Points? ": "是否確認以 {points} ifc積分換領?",
    "Quantity": "數量: ",
    "pc(s)": "",
    "Click \"Confirm\" to proceed.": "按「確認」以繼續。",
    "The redemption cannot be cancelled or changed after confirmation.": "確認後將無法取消或更改。",
    "Cancel": "取消",
    "Confirm": "確認",
    "Done": "完成",
    "Check Rewards": "查看獎賞",
    "Check Gift Voucher": "查看禮券",
    "You have successfully redeemed:": "您已成功換領 ：",
    "Sorry, something went wrong.": "抱歉，發生錯誤。",
    "Please check your network settings and try again.": "請檢查網絡設定然後再試。",
    "OK": "明白"    
}